import { SprinklesElement } from "sprinkles-js";

/**
 * This element autoplays the video when it appears in the screen
 * and stops the video when the player is no longer visible
 *
 * We use autoplay because we show the video in a modal and the user has already clicked to start the video.
 */
export default class VideoPlayerElement extends SprinklesElement {
  static tagName = "video-player";
  static refs = ["frame"];
  static observedAttributes = ["src"];

  constructor() {
    super();
    this.observer = new IntersectionObserver(this.#onAppear.bind(this));
  }

  afterConnected() {
    this.observer.observe(this);
  }

  attributeChangedCallback(name, _, newValue) {
    if (name !== "src") return;

    const src = new URL(newValue);
    const params = new URLSearchParams(src.search);
    params.set("autoplay", "1");
    src.search = params;
    this.autoplaySrc = src;
  }

  #onAppear(entries) {
    // We only expect one entry, since we only have one object and one threshold
    const entry = entries.at(0);
    this.refs.frame.setAttribute(
      "src",
      entry.intersectionRatio > 0 ? this.autoplaySrc : "",
    );
  }
}
